
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import 'element-ui/lib/checkbox';
import PendoCheckbox from './pendo-checkbox.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'lodash/debounce';
import 'dompurify';
import 'lodash/throttle';
import PendoInput from './pendo-input.js';
import './emitter-mixin.js';
import 'element-ui/lib/dialog';
import 'resize-observer-polyfill';
import PendoModal from './pendo-modal.js';

var script = {
  name: 'PendoLegalAcknowledgement',
  components: {
    PendoButton,
    PendoCheckbox,
    PendoInput,
    PendoModal
  },
  props: {
    bodyText: {
      type: String,
      default: ''
    },
    isForCustomer: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'app'
    },
    title: {
      type: String,
      default: 'Acknowledgement'
    },
    actionButtonType: {
      type: String,
      default: 'primary'
    },
    actionButtonLabel: {
      type: String,
      default: 'Confirm'
    },
    width: {
      type: Number,
      default: 425
    }
  },

  data() {
    return {
      confirmationInput: '',
      isForCustomerChecked: false
    };
  },

  computed: {
    disabledLogic() {
      return this.confirmationInput !== 'I understand' || this.isForCustomer && !this.isForCustomerChecked;
    }

  },
  methods: {
    confirmAction() {
      this.$emit('confirm-action');
    },

    closeModal() {
      this.$emit('close', false);
      this.isForCustomerChecked = false;
      this.confirmationInput = '';
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-modal', {
    staticClass: "legal-acknowledgement-modal",
    attrs: {
      "title": _vm.title,
      "height": "auto",
      "max-height": "90%",
      "width": _vm.width,
      "visible": _vm.visible,
      "esc-to-close": false
    },
    on: {
      "close": _vm.closeModal
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('pendo-button', {
          attrs: {
            "theme": _vm.theme,
            "type": "secondary",
            "label": "Cancel"
          },
          on: {
            "click": _vm.closeModal
          }
        }), _vm._v(" "), _c('pendo-button', {
          attrs: {
            "theme": _vm.theme,
            "type": _vm.actionButtonType,
            "label": _vm.actionButtonLabel,
            "disabled": _vm.disabledLogic,
            "loading": _vm.isLoading
          },
          on: {
            "click": _vm.confirmAction
          }
        })];
      },
      proxy: true
    }])
  }, [_vm._t("default", [_c('p', [_vm._v("\n            " + _vm._s(_vm.bodyText) + "\n        ")])]), _vm._v(" "), _c('pendo-input', {
    attrs: {
      "data-cy": "confirm-action-input",
      "label": "Type \"I understand\" to confirm",
      "sanitize": ""
    },
    model: {
      value: _vm.confirmationInput,
      callback: function ($$v) {
        _vm.confirmationInput = $$v;
      },
      expression: "confirmationInput"
    }
  }), _vm._v(" "), _vm.isForCustomer ? _c('pendo-checkbox', {
    staticClass: "pendo-super-confirmation",
    attrs: {
      "label": "I have confirmation to do this on behalf of a customer."
    },
    model: {
      value: _vm.isForCustomerChecked,
      callback: function ($$v) {
        _vm.isForCustomerChecked = $$v;
      },
      expression: "isForCustomerChecked"
    }
  }) : _vm._e()], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-legal-acknowledgement.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoLegalAcknowledgement = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoLegalAcknowledgement;
